const moment = require('moment')

// Função auxiliar para gerar cores da marca
const generateBrandColors = () => {
    return {
        containerBg: 'from-gray-50/80 via-white/80 to-gray-50/80',
        overlayBg: 'from-brand-cyan/5 to-brand-cyan/5',
        decorationBg: 'from-brand-cyan/10 to-brand-cyan/10',
        border: 'border-brand-cyan/20',
        inputBorder: 'border-brand-cyan/30',
        focusRing: 'focus:ring-brand-cyan',
        iconBg: 'from-brand-cyan via-brand-cyan-dark to-brand-cyan-dark',
        textGradient: 'from-brand-dark via-brand-dark to-brand-dark',
        buttonPrimary: 'from-brand-cyan via-brand-cyan-dark to-brand-cyan-dark',
        buttonPrimaryHover: 'hover:from-brand-cyan-dark hover:via-brand-cyan-darker hover:to-brand-cyan-darker',
        buttonSecondaryBorder: 'border-brand-cyan/40',
        buttonSecondaryBg: 'from-brand-cyan/10 to-brand-cyan/10',
        buttonSecondaryBgHover: 'hover:from-brand-cyan/20 hover:to-brand-cyan/20',
        buttonSecondaryText: 'text-brand-cyan-dark',
        buttonOverlay: 'from-brand-cyan/10 to-brand-cyan/10',
        focusRingOffset: 'focus:ring-brand-cyan',
        headerIconBg: 'bg-brand-cyan/20',
        headerIconText: 'text-brand-cyan-dark',
        headerButtonBg: 'bg-brand-cyan',
        headerButtonHover: 'hover:bg-brand-cyan-dark'
    }
}

const brandColors = generateBrandColors()

export const colorMap = {
    indigo: brandColors,
    blue: brandColors,
    green: brandColors,
    purple: brandColors,
    pink: brandColors,
    red: brandColors,
    yellow: brandColors,
    emerald: brandColors,
    teal: brandColors,
    cyan: brandColors,
    orange: brandColors
}

export const perPageOptionsSearch = [
    { value: 1, label: '5 registros' },
    { value: 10, label: '10 registros' },
    { value: 20, label: '20 registros' },
    { value: 50, label: '50 registros' }
]

// Função para formatar data
export const formatDate = (dateString) => {
    if (!dateString) return '-'
    return moment(dateString).format('DD/MM/YYYY')
}

export const formatDateAnTime = (dateString) => {
    if (!dateString) return '-'
    const hour = new Date(dateString).toLocaleString('pt-BR', { hour: '2-digit', minute: '2-digit' })
    const date = new Date(dateString).toLocaleDateString('pt-BR')
    return `${date} ${hour}`
}

// Função para truncar texto
export const truncate = (text, maxLength) => {
    if (!text) return '-'
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text
}


export const formatCnpj = (cnpj) => {
    if (!cnpj) return '-'
    return cnpj.replace(/\D/g, '').replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
}
